export default __webpack_public_path__ + "static/media/BIC-Violet2.ce76dac4.png";